import { Component, Input, OnInit } from '@angular/core';

import { AuthService } from '@app/core/auth';
import { RfqService } from '@app/core/quotes';
import { environment } from '@app/env-service';

@Component({
  selector: 'cnc-rfq-attachments',
  templateUrl: './rfq-attachments.component.html',
  styleUrls: ['./rfq-attachments.component.scss'],
})
export class RfqAttachments implements OnInit {
  @Input() rfq;
  url :string = environment.url;

  constructor(
    public rfqService :RfqService,
    public authSvc :AuthService,
  ) {}

  ngOnInit() {}
}
